// Da usare in DashboardHome (o nel layout dashboard).
// Legge il query param ?verified=1 al primo render,
// mostra un feedback e pulisce l'URL.

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export type VerifiedStatus = 'verified' | 'already' | null;

export function useEmailVerifiedToast(): VerifiedStatus {
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState<VerifiedStatus>(null);

  useEffect(() => {
    const verified = searchParams.get('verified');
    if (verified === '1') {
      setStatus('verified');
    } else if (verified === 'already') {
      setStatus('already');
    }

    if (verified) {
      // Rimuove il param dall'URL senza ricaricare la pagina
      searchParams.delete('verified');
      setSearchParams(searchParams, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return status;
}
